/* Origin -> enquiry category. Initialise each async placement independently;
   never replace a choice the visitor has made. */
(() => {
  if (window.__drHelpPreselect) return;
  window.__drHelpPreselect = true;
  const labels = {
    product: 'Product Enquiry', custom: 'Custom Rug Enquiry', sample: 'Request a Sample',
    'trade-appointment': 'Book Trade Appointment', project: 'Commercial Project',
    'residential-project': 'Residential Project', carpets: 'Axminster Carpet Enquiry',
    shipping: 'International Shipping Enquiry', general: 'General Enquiry',
    media: 'Media / Press', other: 'Other'
  };
  const aliases = {
    faq: 'general', guides: 'general', returns: 'general', account: 'general',
    'book-trade-appointment': 'trade-appointment', 'trade-appointment-request': 'trade-appointment',
    'commercial-project': 'project', 'custom-rug': 'custom', axminster: 'carpets',
    'axminster-carpet': 'carpets', 'international-shipping': 'shipping',
    'request-a-sample': 'sample', press: 'media'
  };
  const norm = value => String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const canonical = value => {
    const key = norm(value);
    return aliases[key] || Object.keys(labels).find(k => norm(labels[k]) === key) || key;
  };
  let edited = new WeakSet();
  const dynamicReady = new WeakSet();
  let queued = false;
  let timer;
  function syncDynamicFields(select, wrapper, changeAlreadySent = false) {
    const builder = window.Globo && window.Globo.FormBuilder;
    if (dynamicReady.has(select) || !builder || typeof builder.hiddenInit !== 'function') return;
    const dependent = [...wrapper.querySelectorAll('input[type="hidden"][data-type="dynamic"]')]
      .some(field => field.dataset.when === select.name);
    if (!dependent) return;
    // Globo attaches its conditional-hidden listener asynchronously. Replay
    // the current selection once it is ready, without replacing a user choice.
    dynamicReady.add(select);
    if (!changeAlreadySent) select.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function apply() {
    const raw = new URLSearchParams(location.search).get('help');
    document.querySelectorAll('[data-help-preselect]').forEach(wrapper => {
      const key = canonical(raw || wrapper.dataset.helpDefault);
      wrapper.querySelectorAll('select').forEach(select => {
        const options = [...select.options];
        if (options.filter(o => labels[canonical(o.value)] || labels[canonical(o.textContent)]).length < 3) return;
        if (edited.has(select)) {
          syncDynamicFields(select, wrapper);
          return;
        }
        const target = labels[key]
          ? options.find(o => canonical(o.value) === key || canonical(o.textContent) === key)
          : options.find(o => !o.value);
        if (!target) return;
        if (select.dataset.helpPreselected !== key) select.dataset.helpPreselected = key;
        const changed = select.value !== target.value;
        if (changed) {
          select.value = target.value;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        syncDynamicFields(select, wrapper, changed);
      });
    });
  }
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; apply(); });
  }
  function settle() {
    queue();
    clearInterval(timer);
    const until = Date.now() + 15000;
    timer = setInterval(() => { apply(); if (Date.now() > until) clearInterval(timer); }, 300);
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form || form.tagName !== 'FORM' || !form.closest('[data-help-preselect]')) return;
    const dynamicFields = [...form.querySelectorAll('input[type="hidden"][data-type="dynamic"]')];
    form.querySelectorAll('select[data-help-preselected]').forEach(select => {
      if (!dynamicFields.some(field => field.dataset.when === select.name)) return;
      // Capture runs before the app's form-submit serialization. Replay the
      // actual current choice even when readiness was reported too early.
      // Do not call apply(): a visitor's selection must never be replaced.
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }, true);
  ['pointerdown', 'keydown', 'change'].forEach(type => document.addEventListener(type, event => {
    if (event.isTrusted && event.target.matches('select[data-help-preselected]')) edited.add(event.target);
  }, true));
  // Native/select-enhancement libraries can emit synthetic change events. Once
  // the visitor focuses the already-initialised control, their selection owns it.
  document.addEventListener('focusin', event => {
    if (event.target.matches('select[data-help-preselected]')) edited.add(event.target);
  }, true);
  function boot() {
    new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
    settle();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('globo.formbuilder.form.loaded', settle);
  document.addEventListener('shopify:section:load', settle);
  window.addEventListener('pageshow', settle);
  window.addEventListener('popstate', () => { edited = new WeakSet(); settle(); });
})();
